import {
  useCloseWipBulkMutation,
  useLockWipBulkMutation,
  useOpenWipBulkMutation,
  useUnlockWipBulkMutation,
} from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { observer } from "mobx-react-lite";
import Actions from "../../Actions";
import type { ProjectWip } from "../../models";
import { useStore } from "../../Store";

interface RowActionsProps {
  row: ProjectWip;
}

const RowActions = ({ row }: RowActionsProps) => {
  const store = useStore();
  const { wipPeriodsStore } = store;

  const [lockWipBulkMutation, { loading: lockLoading }] =
    useLockWipBulkMutation({
      variables: {
        periodId: wipPeriodsStore.currentPeriod?.id!,
        projectId: row.id,
      },
      ...onError(),
      onCompleted() {
        store.refetchProjectsWip();
      },
    });

  const [unlockWipBulkMutation, { loading: unlockLoading }] =
    useUnlockWipBulkMutation({
      variables: {
        periodId: wipPeriodsStore.currentPeriod?.id!,
        projectId: row.id,
      },
      ...onError(),
      onCompleted() {
        store.refetchProjectsWip();
      },
    });

  const [openWipBulkMutation, { loading: openLoading }] =
    useOpenWipBulkMutation({
      variables: {
        periodId: wipPeriodsStore.currentPeriod?.id!,
        projectId: row.id,
      },
      ...onError(),
      onCompleted() {
        store.refetchProjectsWip();
      },
    });

  const [closeWipBulkMutation, { loading: closeLoading }] =
    useCloseWipBulkMutation({
      variables: {
        periodId: wipPeriodsStore.currentPeriod?.id!,
        projectId: row.id,
      },
      ...onError(),
      onCompleted() {
        store.refetchProjectsWip();
      },
    });

  if (!wipPeriodsStore.currentPeriod) {
    return null;
  }

  return (
    <Actions
      size="sm"
      isClosed={row.is_closed}
      isLocked={row.is_locked}
      onOpen={openWipBulkMutation}
      openLoading={openLoading}
      onClose={closeWipBulkMutation}
      closeLoading={closeLoading}
      onLock={lockWipBulkMutation}
      lockLoading={lockLoading}
      onUnlock={unlockWipBulkMutation}
      unlockLoading={unlockLoading}
    />
  );
};

export default observer(RowActions);
